import {Injectable} from '@angular/core';
import {Router, RoutesRecognized} from "@angular/router";
import {filter, pairwise} from "rxjs/operators";

@Injectable()
export class RouteHistoryService {

  private _previousRoute;
  private _router: Router;


  constructor(router: Router) {
    this._router = router;
  }

  get previousRoute() {
    return this._previousRoute || '/';
  }

  initializeRouterHistoryService() {
    this._router.events.pipe(filter((e: any) => e instanceof RoutesRecognized), pairwise()).subscribe((e: RoutesRecognized[]) => {
      this._previousRoute = e[0].urlAfterRedirects;
    });
  }
}
